import { Typography } from "@mui/material";
import EmptyFridgeIllustration from "assets//illustrations/emptyFridgeImage.svg";
import { ErrorBox } from "components/primitives/ErrorBox";
import { ModalContentWrapper } from "components/primitives/ModalContentWrapper";
import { ModalTitle } from "components/primitives/ModalTitle";
import { useMixpanelTrackers } from "hooks/useMixpanelTrackers";
import { useAppSelector } from "hooks/utilsHooks/storeHooks";
import parse from "html-react-parser";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { selectShortFridgeId } from "slices/fridgeInfoSlice";
import { logToSentry } from "utils/logger";
import { BasicModal } from "./BasicModal";

const EmptyFridgeModalContent = () => {
	const fridgeId = useAppSelector(selectShortFridgeId);
	const { t } = useTranslation();
	const { trackTabletEmptyFridgeModal } = useMixpanelTrackers();

	// biome-ignore lint/correctness/useExhaustiveDependencies: intentionally mount/unmount-only for tracking
	useEffect(() => {
		trackTabletEmptyFridgeModal("open");
		logToSentry(`Empty fridge modal displayed on fridge: ${fridgeId}`, "info");
		return () => {
			trackTabletEmptyFridgeModal("close");
		};
	}, []);

	return (
		<ModalContentWrapper>
			<ModalTitle variant="promoHeader">{t("modals.emptyFridgeModal.title")}</ModalTitle>
			<Typography variant="promoText">{t("modals.emptyFridgeModal.description")}</Typography>
			<EmptyFridgeIllustration />
			<ErrorBox mt="auto">
				<Typography display="flex" variant="ctaSubtextBold" color="white" textAlign="center">
					{parse(t("modals.emptyFridgeModal.banner"))}
				</Typography>
			</ErrorBox>
			<Typography variant="filter">
				{t("modals.emptyFridgeModal.fridgeId")}: {fridgeId}
			</Typography>
		</ModalContentWrapper>
	);
};

export const EmptyFridgeModal = () => (
	<BasicModal modalContent={<EmptyFridgeModalContent />} open={true} closable={false} fullHeight={true} />
);
